import { ApiReportReportTypeChoices, ReportSectionsType } from "@api/graphql/types-and-hooks";
import { RECOMMENDATIONS_PAGE_LOCATION } from "@components/ReportField/consts";
import { useReport } from "@providers/ReportProvider";

// Save to folder lives on the stepped Diagnosis Evaluation surface (Evaluation
// details) recommendations page. The single-page Diagnosis Evaluation and the
// assessment surfaces do not offer it.
export const useCanSaveToFolder = (section: ReportSectionsType): boolean => {
  const { report, viewMode } = useReport();
  const isDiagnosisEvaluation = report.reportType === ApiReportReportTypeChoices.DiagnosisEvaluation;
  const isRecommendations = section.pageLocation === RECOMMENDATIONS_PAGE_LOCATION;
  return isDiagnosisEvaluation && viewMode === "step" && isRecommendations;
};
